// extracted by mini-css-extract-plugin
export default {"sobre-nos-content":"styles_sobre-nos-content__000H7","sub-page-content-grey":"styles_sub-page-content-grey__1ykiq","sub-page-content":"styles_sub-page-content__MJLuj"};